import ClientLike from "../client-like";
import PurchaseRepository from "@/usecases/accounting/purchase-management-repository";
import PurchaseManagement from "@/usecases/accounting/purchase-management";
import purchaseStatusTranslater from "@/usecases/accounting/purchase-status-translater";

export default class PurchaseManagementApi implements PurchaseRepository {
  public constructor(private client: ClientLike) {}

  public async find(id: number): Promise<PurchaseManagement | undefined> {
    const res = await this.client.get("get_purchase_management.php", { id });
    if (res.purchases.length > 0) {
      return toPurchase(res.purchases[0]);
    }
  }

  public async findAll(options?: {
    projectId?: string;
    projectName?: string;
    companyId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<PurchaseManagement[]> {
    const res = await this.client.get("get_purchase_management.php", options);
    return res.purchases.map(toPurchase);
  }

  public async save(purchase: PurchaseManagement): Promise<number> {
    const data = await this.client.post(
      "save_purchase_management.php",
      purchase
    );
    return data.id;
  }

  public async destroy(id: number): Promise<void> {
    const d = new FormData();
    d.append("id", String(id));
    await this.client.post("delete_purchase.php", d);
  }
}

function toPurchase(data: any): PurchaseManagement {
  return {
    ...data,
    statusName: purchaseStatusTranslater.toJp(data.status)
  };
}
